import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { addIndication, INDICATION_TYPES } from 'modules/taboola-common-frontend-modules/Indications';
import { useFormState } from 'modules/taboola-common-frontend-modules/forms';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { usePushReportApi } from 'services/api/pushReportApi';
import { errorMessagesUtils } from 'services/utils';
import { useFormDataContext } from '../../taboola-common-frontend-modules/formData';
import { PUSH_API_ROUTE } from '../config/routes/module';
import { removeIds } from '../utils/utils';

export const successIndication = {
    message: (
        <FormattedMessage
            id="push-api.subscription.create.success"
            defaultMessage="Subscription successfully created"
        />
    ),
    type: INDICATION_TYPES.SUCCESS,
    highlight: <FormattedMessage id="success.highlight" defaultMessage="Success!" />,
};

export const generateErrorIndication = (errorObject = {}) => ({
    message: errorMessagesUtils.getErrorMessage(errorObject),
    type: INDICATION_TYPES.ERROR,
    highlight: (
        <FormattedMessage
            id="push-api.subscription.create.error.highlight"
            defaultMessage="Unable to create subscription."
        />
    ),
});

export const useSubscriptionCreatorState = () => {
    const {
        formAccount: { accountId },
    } = useFormDataContext();

    const dispatch = useDispatch();
    const { submit, step, setStep } = useFormState();

    const { createPushReport } = usePushReportApi();

    const submitSubscription = useCallback(
        async subscription => {
            try {
                await createPushReport(accountId, removeIds(subscription));
                dispatch(addIndication(successIndication));
                return true;
            } catch (error) {
                dispatch(addIndication(generateErrorIndication(error)));
                throw error;
            }
        },
        [createPushReport, accountId, dispatch]
    );

    const submitWrapper = useCallback(() => {
        const submitSubscriptionWrapper = subscription => {
            return submitSubscription(subscription);
        };
        submit({
            saveFormData: submitSubscriptionWrapper,
            successUrl: PUSH_API_ROUTE,
        });
    }, [submit, submitSubscription]);

    return { submit: submitWrapper, step, setStep };
};
